// `suffix` defaults to ' ago' for back-compat (Conversations uses the helper
// to render "Last message · 3 hours ago"). Pass '' when the caller's column
// header already conveys the "ago" semantic (e.g. Work Queue "TIME IN PHASE").
export const timeAgo = (dateStr: string | null, suffix = ' ago'): string => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();

    if (diffMs < 0) return 'Just now';

    const minutes = Math.floor(diffMs / (1000 * 60));
    if (minutes < 1) return 'Just now';
    if (minutes === 1) return `1 minute${suffix}`;
    if (minutes < 60) return `${minutes} minutes${suffix}`;

    const hours = Math.floor(minutes / 60);
    if (hours === 1) return `1 hour${suffix}`;
    if (hours < 24) return `${hours} hours${suffix}`;

    const days = Math.floor(hours / 24);
    if (days === 1) return `1 day${suffix}`;
    if (days < 14) return `${days} days${suffix}`;

    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const TIMELINE_HISTORY_STALE_MS = 60_000;

// Wall-clock absolute timestamp ("May 28, 2026, 10:42 AM").
export function formatAbsolute(iso: string): string {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    });
}

// Short relative duration ("just now", "5m ago", "3h ago", "12d ago").
export function formatRelative(iso: string): string {
    const d = new Date(iso);
    const ms = Date.now() - d.getTime();
    if (Number.isNaN(d.getTime()) || ms < 0) return '';
    const min = Math.floor(ms / 60_000);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);
    if (min < 1) return 'just now';
    if (min < 60) return `${min}m ago`;
    if (hr < 24) return `${hr}h ago`;
    if (day < 30) return `${day}d ago`;
    return '';
}
